import { useAppTranslation } from "@/utils";
import { CuToman, FiChevronLeft } from "@payping/icons";
import { formatLocalizedNumber } from "@payping/utilities-shared/number";
import { moment } from "@payping/utils/dateUtils";
import { Button, Card, Divider, Flex, Tag, Typography } from "@payping/web-components";
import { FC } from "react";

interface InstallmentCardProps {
  shopName: string;
  dueDate?: moment.Moment;
  amount?: number;
  penaltyAmount?: number;
  installmentNumber?: number;
  installmentStatus?: string;
  handlePay?: () => void;
}
const HomeOverviewPageInstallmentCard: FC<InstallmentCardProps> = ({
  handlePay,
  shopName,
  amount,
  dueDate,
  installmentNumber,
  penaltyAmount,
}) => {
  const { t } = useAppTranslation();

  return (
    <Card size="small">
      <Flex gap={"middle"} vertical className="tw:w-full">
        <Flex gap={"small"} justify="space-between" className="tw:w-full" align="center">
          <Typography.Text className="tw:m-0!">{shopName}</Typography.Text>
          <Tag className="tw:m-0!">
            {`${t("common.installment")} ${(t("common.countingNumbers", { returnObjects: true }) as string[])[(installmentNumber ?? 1) - 1]}`}
          </Tag>
        </Flex>
        <Flex gap={"small"} justify="space-between" className="tw:w-full" align="center">
          <Typography.Text className="tw:text-xs!" type="secondary">
            {dueDate ? `${t("common.due")} ${dueDate.locale("fa").format("D MMMM YYYY")}` : ""}
          </Typography.Text>
          <Flex align="center" gap={"2px"}>
            <Typography.Text className="tw:mr-auto">{`${formatLocalizedNumber({ value: amount ?? 0 })}`}</Typography.Text>
            <CuToman width={24} height={24} />
          </Flex>
        </Flex>
        {penaltyAmount ? (
          <Flex align="center">
            <Typography.Text className="tw:text-xs!">
              {t("home.installmentCard.penaltyText", {
                amount: `${formatLocalizedNumber({ value: penaltyAmount ?? 0 })}`,
              })}
            </Typography.Text>
            <CuToman width={24} height={24} />
          </Flex>
        ) : null}

        <Divider className="tw:m-0!" />
        <Flex justify="end" align="center" className="tw:w-full">
          <Button className="tw:px-0!" type="link" onClick={handlePay}>
            <Flex gap={"middle"} align="center">
              <Typography.Text className="tw:text-color-primary">{t("common.installmentPayment")}</Typography.Text>
              <FiChevronLeft width={20} />
            </Flex>
          </Button>
        </Flex>
      </Flex>
    </Card>
  );
};

export default HomeOverviewPageInstallmentCard;
